const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[0-9][0-9\s()-]{7,19}$/;
const PASSWORD_MIN_LENGTH = 8;
const RESUME_EXTENSIONS = [".pdf", ".doc", ".docx"];

export function normalizeEmail(value) {
  return (value || "").trim().toLowerCase();
}

export function isValidEmail(value) {
  return EMAIL_REGEX.test(normalizeEmail(value));
}

export function validatePassword(value) {
  const password = value || "";
  if (!password) {
    return "Password is required.";
  }

  const hasLetter = /[A-Za-z]/.test(password);
  const hasNumber = /\d/.test(password);

  if (password.length < PASSWORD_MIN_LENGTH || !hasLetter || !hasNumber) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters and include letters and numbers.`;
  }

  return "";
}

export function validatePhone(value) {
  const phone = (value || "").trim();
  if (!phone) {
    return "Phone number is required.";
  }
  if (!PHONE_REGEX.test(phone)) {
    return "Please enter a valid phone number.";
  }
  return "";
}

export function validateResumeFile(file) {
  if (!file) {
    return "";
  }

  const lowerName = (file.name || "").toLowerCase();
  const hasAllowedExtension = RESUME_EXTENSIONS.some((ext) => lowerName.endsWith(ext));
  if (!hasAllowedExtension) {
    return "Resume must be a PDF, DOC, or DOCX file.";
  }

  if (file.size <= 0) {
    return "Resume file is empty.";
  }

  return "";
}
